export const getMarketsFromMarketGroup = (marketGroup) => {
    const players = marketGroup.players && marketGroup.players.length ? marketGroup.players : [''];
    const periods = marketGroup.periods && marketGroup.periods.length ? marketGroup.periods : [''];
    const teams = marketGroup.teams && marketGroup.teams.length ? marketGroup.teams : [''];
    return { players, periods, teams };
};
